import React from 'react'

import Footer from '../../components/Footer/Footer'
import Header from '../../components/Header/Header'
import Body from '../../components/Body/Body'
export default function LoggedInPage() {
  return (
    <>
    <Header />
   <Body/>
    <Footer/>
    </>
  )
}
